import React, { useEffect, useRef } from 'react';
import anime from 'animejs/lib/anime.es.js';

export default function IconAnimeLogo({ setAnimeLogo, setOpacity }) {
	const rouePath = useRef();
	const greenMoon = useRef();
	const blueMoon = useRef();
	const histoUn = useRef();
	const histoTwo = useRef();
	const histoThree = useRef();
	const whiteCurve = useRef();
	const arrow = useRef();
	const textName = useRef();

	useEffect(() => {
		if (rouePath.current) {
			let timeline = anime.timeline({
				autoplay: true,
				loop: false,
				complete: function (anim) {
					setOpacity(true);
					// const wrapper = document.querySelector('.anime-logo-wrapper');
					// wrapper.classList.add('opacity');
					sessionStorage.setItem('animeLogo', true);
					setAnimeLogo(sessionStorage.getItem('animeLogo'));
				},
			});

			let animationData = [
				{
					name: rouePath.current,
					fill: '#333e50',
					durationDraw: '1600',
					delaiDraw: 0,
					stroke: '#333e50',
					durationColor: '500',
					delayColor: '+=0',
				},
				{
					name: greenMoon.current,
					fill: '#8eaf24',
					durationDraw: '1600',
					delaiDraw: '-=2000',
					stroke: '#333e50',
					durationColor: '500',
					delayColor: '+=0',
				},
				{
					name: blueMoon.current,
					fill: '#333e50',
					durationDraw: '1600',
					delaiDraw: '-=3000*2',
					stroke: '#333e50',
					durationColor: '500',
					delayColor: '-=500',
				},
				{
					name: histoUn.current,
					fill: '#8eaf24',
					durationDraw: '750',
					delaiDraw: '-=1500',
					stroke: '#333e50',
					durationColor: '500',
					delayColor: '-=0',
				},
				{
					name: histoTwo.current,
					fill: '#333e50',
					durationDraw: '750',
					delaiDraw: '-=1000',
					stroke: '#333e50',
					durationColor: '500',
					delayColor: '-=0',
				},
				{
					name: histoThree.current,
					fill: '#333e50',
					durationDraw: '750',
					delaiDraw: '-=900',
					stroke: '#333e50',
					durationColor: '500',
					delayColor: '-=0',
				},
				{
					name: whiteCurve.current,
					fill: 'none',
					durationDraw: '750',
					delaiDraw: '-=800',
					stroke: 'white',
					durationColor: '500',
					delayColor: '-=0',
				},
				{
					name: arrow.current,
					fill: 'none',
					durationDraw: '1200',
					delaiDraw: '-=0',
					stroke: 'white',
					durationColor: '500',
					delayColor: '-=0',
				},
				{
					name: textName.current,
					fill: '#333e50',
					durationDraw: '50',
					delaiDraw: '-=50',
					stroke: '#333e50',
					durationColor: '50',
					delayColor: '-=50',
				},
			];

			animationData.forEach(function (animation, index) {
				if (animation.name === whiteCurve.current) {
					timeline.add(
						{
							targets: animation.name,
							strokeDashoffset: [anime.setDashoffset, 0],
							easing: 'easeInOutCubic',
							duration: animation.durationDraw,
							begin: function (anim) {
								animation.name.setAttribute('stroke', animation.stroke);
							},
						},
						animation.delaiDraw,
					);
				} else if (animation.name === arrow.current) {
					timeline.add({
						targets: animation.name,
						opacity: [
							{ value: 0, duration: 0, delay: 0 },
							{ value: 1, duration: 600, delay: 300 },
						],
						rotate: '-1turn',
						easing: 'easeInOutCubic',
						duration: animation.durationDraw,
					});
				} else if (animation.name === textName.current) {
					timeline.add({
						targets: animation.name,
						duration: animation.durationDraw,
						opacity: [
							{ value: 0, duration: 0, delay: 0 },
							{ value: 1, duration: 1500, delay: 0 }, //3000
						],
					});
				} else {
					timeline
						.add(
							{
								targets: animation.name,
								strokeDashoffset: [anime.setDashoffset, 0],
								easing: 'easeInOutCubic',
								duration: animation.durationDraw,
								begin: function (anim) {
									animation.name.setAttribute('stroke', animation.stroke);
									animation.name.setAttribute('fill', 'none');
									if (whiteCurve.current !== null) {
										whiteCurve.current.setAttribute('stroke', 'none');
									}
									if (animation.name === histoThree.current) {
										histoThree.current.setAttribute('stroke-width', '1px');
									}
								},
							},
							animation.delaiDraw,
						)
						.add(
							{
								targets: animation.name,
								fill: {
									value: ['transparent', animation.fill],
									duration: animation.durationColor,
									//delay: 1000 + index * 30,
									easing: 'easeInOutQuad',
								},
								stroke: {
									value: [animation.stroke, 'none'],
									duration: animation.durationColor,
									//delay: 1000 + index * 30,
									easing: 'easeInOutQuad',
								},

								complete: function (anim) {
									if (animation.name === histoThree.current) {
										histoThree.current.setAttribute('stroke', '#fff');
										histoThree.current.setAttribute('stroke-width', '4px');
									}
								},
							},
							animation.delayColor,
						);
				}
			});
		}
	}, []);

	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1004.11 294.95">
				<g className="texte" opacity="0" ref={textName}>
					<path
						className="green"
						d="M498.28,217.45V244.1H359V72.93h135.6V99.58H393.47v44.51h89.69v26.16H393.47v47.2Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M551.23,235.18q-22.69-11.37-35.57-31.42t-12.87-45.24q0-25.19,13-45.24t35.69-31.42q22.69-11.37,50.82-11.37,22.82,0,41.66,7.33A85.07,85.07,0,0,1,675.81,99.1l-22.29,19.31q-20.16-20-49.62-20-19.11,0-34.23,7.71a58.55,58.55,0,0,0,0,104.9q15.12,7.69,34.23,7.7,29.46,0,49.62-20.3l22.29,19.56a84.82,84.82,0,0,1-32,21.28,115,115,0,0,1-41.8,7.34Q573.92,246.55,551.23,235.18Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M828.4,217.45V244.1H689.08V72.93H824.69V99.58H723.58v44.51h89.7v26.16h-89.7v47.2Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M881.74,235.18q-22.83-11.37-35.83-31.55a81.58,81.58,0,0,1-13-45.11,81.59,81.59,0,0,1,13-45.12q13-20.18,35.83-31.54T933,70.49q28.38,0,51.21,11.37T1020,113.28q13,20.06,13,45.24t-13,45.24q-13,20.06-35.83,31.42T933,246.55Q904.57,246.55,881.74,235.18ZM966.39,211a58.87,58.87,0,0,0,0-104.9Q951.53,98.36,933,98.36t-33.44,7.71a58.87,58.87,0,0,0,0,104.9q14.87,7.69,33.44,7.7T966.39,211Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M368.17,306.5v2.1H358.06V295.12h9.84v2.1h-7.34v3.5h6.52v2.07h-6.52v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M382,308.6l-3.66-5.12-3.62,5.12h-2.85l5-6.87-4.74-6.61H375l3.45,4.8,3.41-4.8h2.71l-4.72,6.51,5.07,7Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M397.71,295.7a4.47,4.47,0,0,1,2,1.65,5.09,5.09,0,0,1,0,5.12,4.42,4.42,0,0,1-2,1.66,7.41,7.41,0,0,1-3,.58h-3.05v3.89h-2.5V295.12h5.55A7.41,7.41,0,0,1,397.71,295.7Zm-.68,6.2a2.77,2.77,0,0,0,0-4,3.89,3.89,0,0,0-2.49-.69h-2.93v5.35h2.93A3.89,3.89,0,0,0,397,301.9Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M415.71,306.5v2.1H405.6V295.12h9.83v2.1H408.1v3.5h6.51v2.07H408.1v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M430,308.6l-2.75-4a3.57,3.57,0,0,1-.52,0h-3v3.93h-2.5V295.12h5.54a7.43,7.43,0,0,1,3.06.58,4.52,4.52,0,0,1,2,1.65,4.68,4.68,0,0,1,.69,2.57,4.63,4.63,0,0,1-.74,2.62,4.47,4.47,0,0,1-2.13,1.63l3.1,4.43Zm-.9-10.67a3.86,3.86,0,0,0-2.48-.69H423.7v5.37h2.93a3.8,3.8,0,0,0,2.48-.7,2.43,2.43,0,0,0,.85-2A2.4,2.4,0,0,0,429.11,297.93Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M440.51,297.24h-4.46v-2.12h11.44v2.12H443V308.6h-2.51Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M452.07,295.12h2.5V308.6h-2.5Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M462.07,308.35a6.36,6.36,0,0,1-2.3-1.17l.87-1.95a6.83,6.83,0,0,0,2,1.07,7.3,7.3,0,0,0,2.42.42,4.29,4.29,0,0,0,2.24-.48,1.49,1.49,0,0,0,.74-1.28,1.21,1.21,0,0,0-.42-.95,2.83,2.83,0,0,0-1-.59c-.43-.14-1-.3-1.74-.48a19.72,19.72,0,0,1-2.49-.73,4.18,4.18,0,0,1-1.64-1.15,3.11,3.11,0,0,1-.68-2.11,3.56,3.56,0,0,1,.61-2,4.08,4.08,0,0,1,1.82-1.45,7.45,7.45,0,0,1,3-.54,10,10,0,0,1,2.43.3,6.87,6.87,0,0,1,2.05.89l-.78,1.95a7.7,7.7,0,0,0-1.85-.79,6.93,6.93,0,0,0-1.87-.27,3.89,3.89,0,0,0-2.21.5,1.55,1.55,0,0,0-.72,1.33,1.19,1.19,0,0,0,.42.94,2.79,2.79,0,0,0,1.05.58c.42.14,1,.3,1.73.48a18,18,0,0,1,2.46.72,4.08,4.08,0,0,1,1.65,1.15,3,3,0,0,1,.68,2.08,3.58,3.58,0,0,1-.6,2,4.08,4.08,0,0,1-1.84,1.45,7.62,7.62,0,0,1-3,.54A10.18,10.18,0,0,1,462.07,308.35Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M485.83,306.5v2.1H475.72V295.12h9.84v2.1h-7.34v3.5h6.51v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M498.75,308.28a1.51,1.51,0,0,1-.46-1.14,1.58,1.58,0,1,1,3.15,0,1.51,1.51,0,0,1-.46,1.14,1.48,1.48,0,0,1-1.11.46A1.52,1.52,0,0,1,498.75,308.28Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M517.29,307.9a6.55,6.55,0,0,1-2.58-2.48,6.79,6.79,0,0,1-.94-3.56,6.88,6.88,0,0,1,.94-3.56,6.81,6.81,0,0,1,2.6-2.48,7.62,7.62,0,0,1,3.68-.89,7.79,7.79,0,0,1,3,.57,6.27,6.27,0,0,1,2.31,1.68l-1.62,1.52a4.71,4.71,0,0,0-3.6-1.58,5,5,0,0,0-2.48.61,4.3,4.3,0,0,0-1.72,1.69,5.21,5.21,0,0,0,0,4.89,4.28,4.28,0,0,0,1.72,1.68,5,5,0,0,0,2.48.61,4.66,4.66,0,0,0,3.6-1.6l1.62,1.54a6.22,6.22,0,0,1-2.32,1.68,7.88,7.88,0,0,1-3,.58A7.54,7.54,0,0,1,517.29,307.9Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M533.73,307.9a6.5,6.5,0,0,1-2.6-2.49,7.11,7.11,0,0,1,0-7.1,6.56,6.56,0,0,1,2.6-2.49,8.2,8.2,0,0,1,7.43,0,6.67,6.67,0,0,1,2.6,2.48,7.21,7.21,0,0,1,0,7.12,6.6,6.6,0,0,1-2.6,2.48,8.12,8.12,0,0,1-7.43,0Zm6.14-1.91a4.36,4.36,0,0,0,1.69-1.69,4.89,4.89,0,0,0,.62-2.44,4.83,4.83,0,0,0-.62-2.43,4.32,4.32,0,0,0-1.69-1.7,5.13,5.13,0,0,0-4.85,0,4.34,4.34,0,0,0-1.7,1.7,4.83,4.83,0,0,0-.62,2.43,4.89,4.89,0,0,0,.62,2.44A4.38,4.38,0,0,0,535,306a5.13,5.13,0,0,0,4.85,0Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M562,295.12V308.6H560l-7.44-9.13v9.13h-2.48V295.12h2.06l7.43,9.13v-9.13Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M569.52,308.35a6.27,6.27,0,0,1-2.3-1.17l.87-1.95a6.83,6.83,0,0,0,2,1.07,7.28,7.28,0,0,0,2.41.42,4.3,4.3,0,0,0,2.25-.48,1.49,1.49,0,0,0,.74-1.28,1.23,1.23,0,0,0-.41-.95,2.93,2.93,0,0,0-1.06-.59c-.42-.14-1-.3-1.73-.48a19.72,19.72,0,0,1-2.49-.73,4.18,4.18,0,0,1-1.64-1.15,3.11,3.11,0,0,1-.68-2.11,3.56,3.56,0,0,1,.61-2,4.08,4.08,0,0,1,1.82-1.45,7.45,7.45,0,0,1,3-.54,10,10,0,0,1,2.43.3,7,7,0,0,1,2.06.89l-.8,1.95a7.63,7.63,0,0,0-1.84-.79,6.93,6.93,0,0,0-1.87-.27,3.89,3.89,0,0,0-2.21.5,1.55,1.55,0,0,0-.72,1.33,1.19,1.19,0,0,0,.42.94,2.79,2.79,0,0,0,1.05.58c.42.14,1,.3,1.73.48a18,18,0,0,1,2.46.72,4.15,4.15,0,0,1,1.65,1.15,3,3,0,0,1,.68,2.08,3.58,3.58,0,0,1-.6,2,4.14,4.14,0,0,1-1.84,1.45,7.64,7.64,0,0,1-3,.54A10.11,10.11,0,0,1,569.52,308.35Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M593.28,306.5v2.1H583.17V295.12H593v2.1h-7.34v3.5h6.51v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M598.77,295.12h2.5V308.6h-2.5Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="green"
						d="M607.61,295.12h2.5v11.36h7v2.12h-9.55Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M629.27,308.28a1.51,1.51,0,0,1-.46-1.14,1.58,1.58,0,1,1,2.7,1.14,1.59,1.59,0,0,1-2.24,0Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M655.37,306.5v2.1H645.26V295.12h9.84v2.1h-7.34v3.5h6.51v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M669.2,308.6l-3.66-5.12-3.62,5.12h-2.85l5-6.87-4.75-6.61h2.84l3.44,4.8,3.41-4.8h2.72L667,301.63l5.07,7Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M678.82,307.9a6.64,6.64,0,0,1-2.59-2.48,7.24,7.24,0,0,1,0-7.12,6.74,6.74,0,0,1,2.6-2.48,7.62,7.62,0,0,1,3.68-.89,7.79,7.79,0,0,1,3,.57,6.27,6.27,0,0,1,2.31,1.68l-1.62,1.52a4.72,4.72,0,0,0-3.6-1.58,5,5,0,0,0-2.48.61,4.3,4.3,0,0,0-1.72,1.69,5.21,5.21,0,0,0,0,4.89,4.28,4.28,0,0,0,1.72,1.68,5,5,0,0,0,2.48.61,4.68,4.68,0,0,0,3.6-1.6l1.62,1.54a6.22,6.22,0,0,1-2.32,1.68,7.88,7.88,0,0,1-3,.58A7.51,7.51,0,0,1,678.82,307.9Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M703.07,306.5v2.1H693V295.12h9.84v2.1h-7.34v3.5H702v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M708.56,295.12h2.5v11.36h7.05v2.12h-9.55Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M722.8,295.12h2.5v11.36h7.05v2.12H722.8Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M747.14,306.5v2.1H737V295.12h9.84v2.1h-7.34v3.5H746v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M764.61,295.12V308.6h-2.06l-7.44-9.13v9.13h-2.48V295.12h2.06l7.43,9.13v-9.13Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M773.48,307.9a6.64,6.64,0,0,1-2.59-2.48,7.24,7.24,0,0,1,0-7.12,6.74,6.74,0,0,1,2.6-2.48,7.62,7.62,0,0,1,3.68-.89,7.83,7.83,0,0,1,3,.57,6.27,6.27,0,0,1,2.31,1.68l-1.62,1.52a4.72,4.72,0,0,0-3.6-1.58,5,5,0,0,0-2.48.61,4.3,4.3,0,0,0-1.72,1.69,5.13,5.13,0,0,0,0,4.89,4.28,4.28,0,0,0,1.72,1.68,5,5,0,0,0,2.48.61,4.68,4.68,0,0,0,3.6-1.6l1.62,1.54a6.22,6.22,0,0,1-2.32,1.68,7.88,7.88,0,0,1-3,.58A7.51,7.51,0,0,1,773.48,307.9Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M797.73,306.5v2.1H787.62V295.12h9.84v2.1h-7.33v3.5h6.51v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M813.82,307.9a6.63,6.63,0,0,1-2.6-2.49,7.11,7.11,0,0,1,0-7.1,6.7,6.7,0,0,1,2.6-2.49,8.2,8.2,0,0,1,7.43,0,6.67,6.67,0,0,1,2.6,2.48,7.21,7.21,0,0,1,0,7.12,6.6,6.6,0,0,1-2.6,2.48,8.12,8.12,0,0,1-7.43,0ZM820,306a4.36,4.36,0,0,0,1.69-1.69,4.89,4.89,0,0,0,.62-2.44,4.83,4.83,0,0,0-.62-2.43,4.32,4.32,0,0,0-1.69-1.7,5.13,5.13,0,0,0-4.85,0,4.34,4.34,0,0,0-1.7,1.7,4.82,4.82,0,0,0-.61,2.43,4.88,4.88,0,0,0,.61,2.44,4.38,4.38,0,0,0,1.7,1.69,5.13,5.13,0,0,0,4.85,0Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M838.75,295.7a4.47,4.47,0,0,1,2,1.65,5.09,5.09,0,0,1,0,5.12,4.42,4.42,0,0,1-2,1.66,7.43,7.43,0,0,1-3.06.58h-3v3.89h-2.5V295.12h5.54A7.43,7.43,0,0,1,838.75,295.7Zm-.69,6.2a2.74,2.74,0,0,0,0-4,3.84,3.84,0,0,0-2.48-.69h-2.93v5.35h2.93A3.84,3.84,0,0,0,838.06,301.9Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M856.74,306.5v2.1H846.63V295.12h9.84v2.1h-7.33v3.5h6.51v2.07h-6.51v3.71Zm-4.17-15.12h2.83L852,294H850Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M871.05,308.6l-2.75-4a3.57,3.57,0,0,1-.52,0h-3v3.93h-2.5V295.12h5.54a7.43,7.43,0,0,1,3.06.58,4.52,4.52,0,0,1,2,1.65,4.68,4.68,0,0,1,.69,2.57,4.63,4.63,0,0,1-.74,2.62,4.37,4.37,0,0,1-2.13,1.63l3.1,4.43Zm-.9-10.67a3.84,3.84,0,0,0-2.48-.69h-2.93v5.37h2.93a3.78,3.78,0,0,0,2.48-.7,2.43,2.43,0,0,0,.85-2A2.4,2.4,0,0,0,870.15,297.93Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M887.75,305.48H881l-1.33,3.12H877.1l6.07-13.48h2.46l6.09,13.48H889.1Zm-.82-2-2.55-5.9-2.52,5.9Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M898.19,297.24h-4.47v-2.12h11.44v2.12H900.7V308.6h-2.51Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M909.75,295.12h2.5V308.6h-2.5Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M921.17,307.9a6.56,6.56,0,0,1-2.6-2.49,7.11,7.11,0,0,1,0-7.1,6.63,6.63,0,0,1,2.6-2.49,8.2,8.2,0,0,1,7.43,0,6.67,6.67,0,0,1,2.6,2.48,7.15,7.15,0,0,1,0,7.12,6.6,6.6,0,0,1-2.6,2.48,8.12,8.12,0,0,1-7.43,0Zm6.14-1.91a4.38,4.38,0,0,0,1.7-1.69,4.88,4.88,0,0,0,.61-2.44,4.82,4.82,0,0,0-.61-2.43,4.34,4.34,0,0,0-1.7-1.7,5.13,5.13,0,0,0-4.85,0,4.32,4.32,0,0,0-1.69,1.7,4.73,4.73,0,0,0-.62,2.43,4.79,4.79,0,0,0,.62,2.44,4.36,4.36,0,0,0,1.69,1.69,5.13,5.13,0,0,0,4.85,0Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M949.48,295.12V308.6h-2.06L940,299.47v9.13H937.5V295.12h2.06l7.43,9.13v-9.13Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M967.78,295.12V308.6h-2.06l-7.44-9.13v9.13H955.8V295.12h2.06l7.43,9.13v-9.13Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M984.2,306.5v2.1H974.09V295.12h9.84v2.1h-7.34v3.5h6.52v2.07h-6.52v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M989.69,295.12h2.5v11.36h7v2.12h-9.55Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M1003.93,295.12h2.5v11.36h7.05v2.12h-9.55Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M1028.27,306.5v2.1h-10.11V295.12H1028v2.1h-7.34v3.5h6.51v2.07h-6.51v3.71Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="roue">
					<path
						ref={rouePath}
						fill="none"
						stroke="white"
						strokeWidth="1"
						className="blue"
						d="M298.72,136.44a126.23,126.23,0,0,0-9.81-38.08,15.38,15.38,0,0,1-14.67-25.28l.42-.45a122,122,0,0,0-24-24l-.29.27A15.38,15.38,0,0,1,225.05,34c0-.06,0-.11,0-.17a120.71,120.71,0,0,0-32.74-8.75h0a15.38,15.38,0,0,1-29.56,0s0,0,0,0A120.88,120.88,0,0,0,130,33.85c0,.1.05.19.06.29a15.38,15.38,0,0,1-25.24,14.93l-.43-.4a122.49,122.49,0,0,0-24,24l.58.63A15.38,15.38,0,0,1,66.49,98.42q-.42-.08-.84-.18A120.34,120.34,0,0,0,56.91,131l.42.13a15.38,15.38,0,0,1-.42,29.44,120.13,120.13,0,0,0,8,30.82,15.37,15.37,0,0,1,12,26.66l-.2.14c21.81,33.44,58.89,55.49,101.07,55.49,67.17,0,121.62-55.84,121.62-124.72Q299.33,142.61,298.72,136.44Zm-23.25,59a.17.17,0,0,1,0,.1,96.34,96.34,0,0,1-32.81,44.6l0,0c-.94.71-1.9,1.4-2.87,2.08l-.42.29c-.89.62-1.79,1.22-2.71,1.81l-.86.54c-.81.5-1.62,1-2.44,1.49-1.13.66-2.28,1.31-3.44,1.93s-2.54,1.32-3.83,1.93c-.43.21-.87.41-1.3.6l-1.74.78c-1.75.77-3.54,1.48-5.35,2.13-1.22.45-2.46.88-3.71,1.26-.53.18-1.07.34-1.6.49a2,2,0,0,1-.35.11l-1.28.37q-.6.18-1.2.33l-1.09.28c-1.26.32-2.53.61-3.8.88l-1.14.23-1.41.27-.61.11c-.67.12-1.35.23-2,.33s-1.31.2-2,.28l-.65.08c-.73.1-1.46.18-2.19.25s-1.62.16-2.44.22-1.63.12-2.45.15-1.56.08-2.34.09h-.21c-.77,0-1.55,0-2.33,0h-.07c-2.46,0-4.91-.09-7.32-.28-1.55-.12-3.1-.27-4.63-.46q-1.11-.13-2.22-.3c-.73-.11-1.45-.22-2.17-.35A96.22,96.22,0,0,1,155.77,71.59h0c1.3-.42,2.6-.8,3.92-1.15s2.66-.69,4-1q1.06-.24,2.13-.45c1.42-.29,2.85-.54,4.29-.76a93.69,93.69,0,0,1,9.7-1c1.66-.1,3.33-.14,5-.14a95,95,0,0,1,14.88,1.16l2.08.35c.63.1,1.26.22,1.88.36l.59.11,1.52.33c.36.07.71.16,1.06.25l1.9.46,1.15.31.23.06,1.44.4,1,.31,1.08.34,1,.29,1.56.52c.48.17.95.33,1.42.51l.93.35.47.17.11,0,.29.12h0l1.73.68.41.17.43.18.67.29,1,.43,1.16.52c1,.44,1.91.9,2.85,1.37l.44.21,1.29.67c.36.18.71.37,1.06.57l.8.44.65.36q.24.12.48.27l.58.34,1.13.66.5.3,1.59,1,.09.06h0l1.55,1,1,.63.06.05,0,0,.24.17,1.06.73c.38.26.75.54,1.13.81l.28.21,1.14.84.92.71.7.55c.5.4,1,.8,1.49,1.21L247,90l.68.57c.37.31.74.64,1.1,1l.16.14,1,.89c.37.33.74.68,1.11,1l.15.15c.56.52,1.11,1.06,1.65,1.61s1,1.06,1.57,1.6l0,0c.54.55,1.06,1.12,1.58,1.69s1.06,1.18,1.58,1.78,1,1.14,1.44,1.71,1,1.19,1.45,1.8a1.83,1.83,0,0,0,.13.16c.44.55.87,1.11,1.28,1.68q1.39,1.84,2.68,3.77c.87,1.28,1.71,2.58,2.5,3.9.4.66.8,1.33,1.18,2s.74,1.29,1.09,1.94c0,.07.07.13.1.19q1.08,2,2.07,4l0,0c.67,1.39,1.3,2.81,1.91,4.23a.77.77,0,0,0,.07.16c.37.87.72,1.74,1.06,2.62.25.66.5,1.32.74,2,.18.5.36,1,.53,1.51.53,1.5,1,3,1.45,4.55l0,0c.58,2,1.1,4,1.54,6.1a96.67,96.67,0,0,1-3.32,52.63Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="blue-moon">
					<path
						ref={blueMoon}
						fill="none"
						stroke="white"
						strokeWidth="1"
						className="blue"
						d="M278.77,64.84A146.67,146.67,0,0,1,302,118c.13.6.26,1.2.38,1.8.24,1.2.47,2.4.69,3.61.11.61.21,1.21.31,1.82s.17,1,.24,1.53q.53,3.31.88,6.68c.19,1.68.34,3.37.46,5.06q.36,4.68.4,9.43c0,.52,0,1,0,1.57a147.15,147.15,0,0,1-77.61,129.86c-.77.42-1.55.84-2.34,1.24s-1.3.67-2,1l-1.87.92A147.57,147.57,0,0,1,56.09,256.73,147.74,147.74,0,0,0,177.3,320.05c81.52,0,147.82-66.31,147.82-147.82A147.41,147.41,0,0,0,278.77,64.84Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="histo-1">
					<path
						ref={histoUn}
						fill="none"
						stroke="white"
						strokeWidth="1"
						className="green"
						d="M116.35,134.39v87.28a91.16,91.16,0,0,0,35,24.77v-112Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="histo-2">
					<path
						ref={histoTwo}
						fill="none"
						stroke="white"
						strokeWidth="1"
						className="blue"
						d="M164,98.4v152a91.08,91.08,0,0,0,35,1.3V98.4Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="histo-3">
					<path
						ref={histoThree}
						fill="none"
						stroke="white"
						strokeWidth="1"
						className="blue"
						d="M211.64,250.79a2,2,0,0,1-2-2V71.08a2,2,0,0,1,2-2h35a2,2,0,0,1,2,2V229.5A2,2,0,0,1,248,231a94.56,94.56,0,0,1-35.75,19.71A2.1,2.1,0,0,1,211.64,250.79Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="courbe-blanche">
					<polyline
						ref={whiteCurve}
						className="line-white"
						points="58.86 170.03 104.61 147.4 155.04 141.69 234.81 70.12"
						fill="none"
						stroke="none"
						strokeWidth="10"
						strokeLinecap="round"
						strokeMiterlimit="10"
					/>
				</g>
				<g className="arrow" opacity="0" ref={arrow}>
					<path
						className="white"
						d="M318.72,177.65a6.6,6.6,0,0,1-5.69,3.28H302.08a.12.12,0,0,0-.13.1c-14.56,66.33-73.76,116.13-144.39,116.13A147.34,147.34,0,0,1,56.16,256.8a.14.14,0,0,1,0-.16l20.4-38.28a.13.13,0,0,1,.22,0,123.61,123.61,0,0,0,65.06,47c1.25.38,2.52.74,3.8,1.08a111,111,0,0,0,32.37,5.3,96.35,96.35,0,0,0,50.82-15.27h0c.07,0,.14-.1.22-.14.78-.5,1.56-1,2.33-1.54l.31-.21q1-.71,2-1.44c.18-.11.33-.23.49-.35.76-.54,1.49-1.09,2.22-1.64.12-.1.24-.2.37-.29.63-.49,1.26-1,1.87-1.49l.49-.39c.7-.57,1.39-1.15,2.06-1.74l.44-.38c.57-.49,1.14-1,1.69-1.51l.51-.45c.64-.59,1.27-1.19,1.91-1.8l.49-.48c.51-.49,1-1,1.51-1.49l.51-.53c.6-.61,1.18-1.22,1.76-1.83l.54-.6c.45-.48.89-1,1.32-1.46.18-.2.37-.4.55-.61.54-.61,1.06-1.23,1.59-1.85l.6-.72,1.13-1.39.57-.72c.48-.61,1-1.23,1.42-1.84.22-.29.42-.58.64-.86s.64-.86.94-1.29l.6-.83c.43-.61.86-1.22,1.27-1.82l.67-1,.76-1.16.9-1.41.84-1.35c.22-.37.45-.75.66-1.12s.41-.67.6-1c.36-.62.71-1.24,1.06-1.86.18-.33.36-.66.55-1s.45-.83.67-1.24l.43-.86c.38-.74.77-1.48,1.13-2.21.11-.26.24-.49.35-.74.22-.45.43-.91.64-1.36l.32-.68,1.09-2.47.24-.59c.21-.48.4-1,.59-1.45.08-.16.14-.33.21-.5.35-.9.7-1.8,1-2.7.07-.15.12-.31.18-.46.18-.51.36-1,.52-1.51.05-.11.08-.23.12-.34a90,90,0,0,0,4-16.63.13.13,0,0,0-.13-.15H268.44a6.85,6.85,0,0,1-5.16-2.19,6.55,6.55,0,0,1-.79-7.66l21.27-36.84a5.22,5.22,0,0,1,.45-.67l.17-.22c.11-.13.22-.26.33-.37a3.45,3.45,0,0,1,.28-.26,2.26,2.26,0,0,1,.28-.25,3,3,0,0,1,.35-.27l.22-.15a6.57,6.57,0,0,1,2.47-1,6.1,6.1,0,0,1,1.13-.12,6.43,6.43,0,0,1,1.16.12,6.34,6.34,0,0,1,1.16-.12,6.49,6.49,0,0,1,3.67,1.15,6.68,6.68,0,0,1,2,2.14l14.73,25.51,6.54,11.33A6.59,6.59,0,0,1,318.72,177.65Z"
						transform="translate(-28.89 -25.1)"
					/>
					<path
						className="blue"
						d="M322.19,169.08l-6.55-11.33-14.73-25.51,0-.05a10.61,10.61,0,0,0-3.22-3.41,10.37,10.37,0,0,0-5.9-1.83,9.25,9.25,0,0,0-1.16.07,9.48,9.48,0,0,0-1.16-.07,9.72,9.72,0,0,0-1.87.19,10.51,10.51,0,0,0-3.89,1.54c-.11.07-.25.16-.41.28a6.41,6.41,0,0,0-.58.45,5.61,5.61,0,0,0-.43.38c-.16.14-.29.27-.38.36a6.48,6.48,0,0,0-.55.62c-.06.06-.11.13-.17.2l-.15.2a10.1,10.1,0,0,0-.74,1.11L259,169.08a10.57,10.57,0,0,0,1.25,12.32,10.88,10.88,0,0,0,8.16,3.53H274A87.62,87.62,0,0,1,271,196.4l-.06.18-.09.25c-.12.39-.26.77-.4,1.17l-.06.17-.07.18,0,.05-.12.32c-.29.82-.61,1.66-1,2.55l-.05.13,0,.08c-.05.09-.08.18-.12.27l-.08.2c-.15.37-.29.75-.45,1.12l0,.05-.24.59-1,2.36-.14.31-.15.3-.17.37-.45,1a1,1,0,0,0-.07.15l-.09.17c-.07.16-.15.32-.23.49-.23.47-.48,1-.72,1.43l-.34.64,0,.09-.37.74-.16.29c-.15.29-.3.57-.46.85s-.37.66-.56,1c-.34.6-.67,1.2-1,1.79l-.06.1c-.15.29-.31.55-.48.83l-.08.13c-.15.26-.31.52-.46.79l-.13.21-.55.89-.28.44-.42.66-.45.71c-.23.36-.47.72-.72,1.09l-.32.48-.35.52c-.37.55-.79,1.14-1.21,1.73-.17.25-.36.51-.54.76l-.07.09c-.27.39-.55.77-.84,1.15l-.42.57-.23.3-.41.54-1,1.25-.57.71-.15.19c-.31.38-.61.76-.92,1.13l0,0-.54.64-.4.47c-.37.44-.74.88-1.13,1.31l0,0-.27.3-.21.23c-.44.5-.85,1-1.27,1.4l-.06.07-.34.38-.16.17-1.67,1.75-.06.05-.21.23-.24.24-.58.58-.85.84-.06.05-.21.21-.24.24-1.83,1.72-.24.21-.21.18-.1.09c-.52.5-1.08,1-1.55,1.39l-.11.1-.24.21-.12.1c-.6.52-1.24,1.06-2,1.64l-.19.15-.29.24q-.87.71-1.74,1.38c-.18.13-.34.26-.46.36-.7.53-1.37,1-2.06,1.52l-.08.06-.11.08-.1.08-.24.16c-.62.45-1.25.9-1.89,1.33l-.39.27c-.59.41-1.27.86-2.11,1.39l-.19.12-.11.07A91.94,91.94,0,0,1,178,267.69a107.39,107.39,0,0,1-31.16-5.12l-.17-.05c-1.26-.33-2.49-.68-3.67-1A120,120,0,0,1,80,216a4.54,4.54,0,0,0-.77-.81c-.38.54-.84,1.11-1.25,1.62a8.28,8.28,0,0,1-1.26,1.25l-.11.08a2.32,2.32,0,0,1,.22.3,123.56,123.56,0,0,0,65,46.84c1.25.38,2.52.74,3.8,1.08a111,111,0,0,0,32.37,5.3,96.35,96.35,0,0,0,50.82-15.27h0c.07,0,.14-.1.22-.14.78-.5,1.56-1,2.33-1.54l.31-.21q1-.71,2-1.44c.18-.11.33-.23.49-.35.76-.54,1.49-1.09,2.22-1.64.12-.1.24-.2.37-.29.63-.49,1.26-1,1.87-1.49l.49-.39c.7-.57,1.39-1.15,2.06-1.74l.44-.38c.57-.49,1.14-1,1.69-1.51l.51-.45c.64-.59,1.27-1.19,1.91-1.8l.49-.48c.51-.49,1-1,1.51-1.49l.51-.53c.6-.61,1.18-1.22,1.76-1.83l.54-.6c.45-.48.89-1,1.32-1.46.18-.2.37-.4.55-.61.54-.61,1.06-1.23,1.59-1.85l.6-.72,1.13-1.39.57-.72c.48-.61,1-1.23,1.42-1.84.22-.29.42-.58.64-.86s.64-.86.94-1.29l.6-.83c.43-.61.86-1.22,1.27-1.82l.67-1,.76-1.16.9-1.41.84-1.35c.22-.37.45-.75.66-1.12s.41-.67.6-1c.36-.62.71-1.24,1.06-1.86.18-.33.36-.66.55-1s.45-.83.67-1.24l.43-.86c.38-.74.77-1.48,1.13-2.21.11-.26.24-.49.35-.74.22-.45.43-.91.64-1.36l.32-.68,1.09-2.47.24-.59c.21-.48.4-1,.59-1.45.08-.16.14-.33.21-.5.35-.9.7-1.8,1-2.7.07-.15.12-.31.18-.46.18-.51.36-1,.52-1.51.05-.11.08-.23.12-.34a90,90,0,0,0,4-16.63.13.13,0,0,0-.13-.15H268.44a6.85,6.85,0,0,1-5.16-2.19,6.55,6.55,0,0,1-.79-7.66l21.27-36.84a5.22,5.22,0,0,1,.45-.67l.17-.22c.11-.13.22-.26.33-.37a3.45,3.45,0,0,1,.28-.26,2.26,2.26,0,0,1,.28-.25,3,3,0,0,1,.35-.27l.22-.15a6.57,6.57,0,0,1,2.47-1,6.1,6.1,0,0,1,1.13-.12,6.43,6.43,0,0,1,1.16.12,6.34,6.34,0,0,1,1.16-.12,6.49,6.49,0,0,1,3.67,1.15,6.68,6.68,0,0,1,2,2.14l14.73,25.51,6.54,11.33a6.57,6.57,0,0,1-5.69,9.85H302.08a.12.12,0,0,0-.13.1c-14.56,66.33-73.76,116.13-144.39,116.13-38.91,0-75-15.78-101.47-40.43,0,.08.56.76.61.87.77,1.08,1.68,2.34,2.74,3.73s3.21,4.17,6.12,7.53c.93,1.08,2,2.25,3.1,3.47a151.38,151.38,0,0,0,184.65-5.26,152.65,152.65,0,0,0,51.84-82.14H313a10.57,10.57,0,0,0,9.16-15.85Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
				<g className="green-moon">
					<path
						ref={greenMoon}
						fill="none"
						stroke="white"
						strokeWidth="1"
						className="green"
						d="M183.16,279.54c-72.45,0-131.38-58.9-131.38-131.3A131.17,131.17,0,0,1,104.49,43.15,131.45,131.45,0,0,0,28.89,162c0,72.39,58.93,131.29,131.39,131.29a130.67,130.67,0,0,0,78.66-26.21A130.56,130.56,0,0,1,183.16,279.54Z"
						transform="translate(-28.89 -25.1)"
					/>
				</g>
			</svg>
			<style jsx>
				{`
					svg {
						position: relative;
					}

					.texte .blue {
						fill: #333e50;
					}
					.texte .green {
						fill: #8eaf24;
					}

					.arrow {
						transform-origin: 142px 137px;
					}
					.arrow .white {
						fill: #fff;
					}
					.arrow .blue {
						fill: #333e50;
					}
				`}
			</style>
		</>
	);
}
